import {
    evictRegisteredMachineDetails,
    persistRegisteredMachineDetails,
} from '../../../constants/registeredMachineUtils';
import {
    CLEAR_REGISTERED_MACHINE,
    FETCH_REGISTERED_MACHINE_FAILURE,
    FETCH_REGISTERED_MACHINE_SUCCESS,
} from './registeredMachine-actions';

const registeredMachineReducer = (state = {}, action) => {
    let newState;
    switch (action.type) {
    case FETCH_REGISTERED_MACHINE_SUCCESS:
        newState = action.registeredMachineDetails;
        persistRegisteredMachineDetails(action.registeredMachineDetails);
        break;
    case FETCH_REGISTERED_MACHINE_FAILURE:
    case CLEAR_REGISTERED_MACHINE:
        newState = {};
        evictRegisteredMachineDetails();
        break;
    default:
        newState = state;
    }
    return newState;
};

export default registeredMachineReducer;
